import React, { PureComponent } from 'react';
import { Checkbox } from 'semantic-ui-react';
import message from '../../../helper/message';
import './Boolean.css';

export default class Boolean extends PureComponent {
  onChange = (ev, { checked }) => {
    const { actions, attributeName, setAppState } = this.props;
    const newAppState = actions.setConfiguration({
      attribute: attributeName,
      value: { value: checked },
    });
    setAppState(newAppState);
  };

  render() {
    const { appApi, attributeName, configuration, disabled } = this.props;
    const option = appApi.config.getAttributeAvailableValues(
      attributeName,
      configuration
    );
    const { label, autoHide } = appApi.config.getAttribute(attributeName);
    if (option.length > 2)
      message.warn(
        `Boolean attribute ${attributeName} has more than one available options!`
      );

    if (autoHide && !option.length) return <div />;

    return (
      <div className="attrContainer booleanAttrContainer">
        {label && <div className="booleanLabel label">{label}</div>}
        {option.length && (
          <Checkbox
            toggle
            disabled={disabled}
            label={option[0].text}
            checked={configuration[attributeName].value}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/Boolean.js